<template>
  <!-- <v-row justify="center"> -->
    <v-footer padless dark height='auto'>
      <!-- <v-col cols="12"> -->
        <v-card flat tile width="100%" class='primary text-center'>
          <v-card-text class='white--text'>
            <strong>Regenerative Building Simulator via Digital Engineering & Data Analytics</strong><br />
            &copy;2019 <strong>Aerospace Systems Design Laboratory</strong>
          </v-card-text>
        </v-card>
      <!-- </v-col> -->
    </v-footer>
  <!-- </v-row> -->
</template>

<script>
export default {
  data: () => ({
    icons: [
      'fab fa-facebook',
      'fab fa-twitter',
      'fab fa-google-plus',
      'fab fa-linkedin',
      'fab fa-instagram'
    ]
  })
}
</script>
